<script setup lang="ts">
import { Enums } from "@/enums";
import { computed } from "vue";
import { assertUnhandledStatus } from "../../common/asserts.common";

const props = defineProps<{
    status: Enums.ProvisionReturnStatusEnum.Values;
}>();

const label = computed(() => Enums.ProvisionReturnStatusEnum.label(props.status));
const color = computed(() => {
    switch (props.status) {
        case "W":
            return "bg-blue-500";
        case "D":
            return "bg-black";
        default:
            return assertUnhandledStatus(props.status);
    }
});
</script>

<template>
    <div class="rns-g-badge" :class="color">{{ label }}</div>
</template>

<style>
@reference "@/styles/main.css";
</style>
